// based on rc-tree 2.1.3
'use strict'

module.exports = require('./src/')
